<template>
  <div>
      <h4 class="text-center" v-if="$refs.calendar"> {{ $refs.calendar.title }} </h4>
    <v-sheet tile height="54" class="d-flex" >
      <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-select v-model="type" :items="types" dense outlined hide-details class="ma-2" label="Tipo De Calendario" ></v-select>
      <!-- <v-select v-model="mode" :items="modes" dense outlined hide-details label="event-overlap-mode" class="ma-2" ></v-select>
      <v-select v-model="weekday" :items="weekdays" dense outlined hide-details label="weekdays" class="ma-2" ></v-select> -->
      <v-spacer></v-spacer>
      <v-btn icon class="ma-2" @click="$refs.calendar.next()" >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-sheet>
    <v-sheet height="600">
      <v-calendar ref="calendar" v-model="value" :weekdays="weekday" :type="gettipo" :events="events" :event-overlap-mode="mode" :event-overlap-threshold="30" :event-color="getEventColor" xchange="getEvents"></v-calendar>
    </v-sheet>
  </div>
</template>

<script>
  export default {
    data: () => ({
      type: 'Mes',
    //   types: ['month', 'week', 'day', '4day'],
      types: ['Mes', 'Semana', 'Dia', '4 Dias'],
      mode: 'stack',
      modes: ['stack', 'column'],
      weekday: [0, 1, 2, 3, 4, 5, 6],
      weekdays: [
        { text: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
        { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
        { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
        { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
      ],
      value: '',
      events: [],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
    }),
    computed:{
        gettipo(){ 
            if(this.type == 'Mes') return 'month';
            if(this.type == 'Semana') return 'week';
            if(this.type == 'Dia') return 'day';
            if(this.type == '4 Dias') return '4day';
            return 'month';
        }
    },
    methods: {
        openmodal(horario){
            this.type = 'Mes';
            this.events = [];
            let horas = []
            horario.forEach(x=>{
                const [hora1, fecha1] = x.Ingreso.split(" "); 
                const [hora2, fecha2] = x.Salida.split(" "); 
                const [dia1, mes1, año1] = fecha1.split("/"); 
                const [dia2, mes2, año2] = fecha2.split("/"); 
                const fechaISO1 = `${año1}-${mes1}-${dia1}T${hora1}:00`;
                const fechaISO2 = `${año2}-${mes2}-${dia2}T${hora2}:00`;
                horas.push( {
                    name: x.Nombre_session,
                    start: fechaISO1,
                    end: fechaISO2,
                    color: this.colors[this.rnd(0, this.colors.length - 1)],
                    timed: false,
                } );
            });
            this.events = horas;
        }, 
        getEventColor (event) {
            return event.color
        },
        rnd (a, b) {
            return Math.floor((b - a + 1) * Math.random()) + a
        },
    },
  }
</script>
